import React from 'react';
import { Link } from 'react-router-dom';

const NewsOne = () => {
    return(
        <>
        {/*Blog Section*/}
        <section className="blog-section section-padding-all">
            <div className="default-container">
            <div className="row clearfix">
                <div className="con-title-column col-lg-12 col-md-12 col-sm-12">
                {/*Sec Title*/}
                <div className="sec-con-title text-center centered mx-auto">
                    <div className="con-title-text con-title-border-l">It's Best Simple &amp; Useful</div>
                    <h2>Latest News</h2>
                    <div className="text">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</div>
                </div>
                </div>
            </div>
            <div className="row clearfix mt-3">
                <div className="col-lg-4 mb-4 field-overlay-holder">
                <div className="img_blog field-overlay-inner">
                    <div className="field-position-m field-mover-border">
                    <img src="images/blog/bl-01-750x430.png" alt="" className="img-fluid mx-auto d-block" />
                    </div>
                </div>
                <div className="blog-box-detail p-4">
                    <div className="mt-0">
                    <p className="labal text-muted">Building Renovation</p>
                    <h5 className="font-weight-bold"><Link to="#" className="read-more">Commercial design for project</Link></h5>
                    <p className="text-muted">It is a long established fact that a reader will be distracted by the readable content</p>
                    <p className="space-date text-muted"> Kazi Porag - 27 May 2022</p>
                    <Link className="read-more text-uppercase font-weight-bold" to="/single-post">Read More</Link>
                    </div>
                </div>
                </div>
                <div className="col-lg-4 mb-4 field-overlay-holder">
                <div className="img_blog field-overlay-inner">
                    <div className="field-position-m field-mover-border">
                    <img src="images/blog/bl-02-750x430.png" alt="" className="img-fluid mx-auto d-block" />
                    </div>
                </div>
                <div className="blog-box-detail p-4">
                    <div className="mt-0">
                    <p className="labal text-muted">Building Maintenance</p>
                    <h5 className="font-weight-bold"><Link to="#" className="read-more">Our interior design prediction</Link></h5>
                    <p className="text-muted">It is a long established fact that a reader will be distracted by the readable content</p>
                    <p className="space-date text-muted"> Kazi Porag -28 May 2022</p>
                    <Link className="read-more text-uppercase font-weight-bold" to="/single-post">Read More</Link>
                    </div>
                </div>
                </div>
                <div className="col-lg-4 mb-4 field-overlay-holder">
                <div className="img_blog field-overlay-inner">
                    <div className="field-position-m field-mover-border">
                    <img src="images/blog/bl-03-750x430.png" alt="" className="img-fluid mx-auto d-block" />
                    </div>
                </div>
                <div className="blog-box-detail p-4">
                    <div className="mt-0">
                    <p className="labal text-muted">Architecture Design</p>
                    <h5 className="font-weight-bold"><Link to="#" className="read-more">Low cost interior designing</Link></h5>
                    <p className="text-muted">It is a long established fact that a reader will be distracted by the readable content</p>
                    <p className="space-date text-muted"> Kazi Porag -28 May 2022</p>
                    <Link className="read-more text-uppercase font-weight-bold" to="/single-post">Read More</Link>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </section>
        {/*End Blog Section*/}
        </>
    )
}

export default NewsOne;